// Load QRCode.js library
const script = document.createElement('script');
script.src = 'https://cdn.jsdelivr.net/npm/qrcode@1.5.1/build/qrcode.min.js';
document.head.appendChild(script);

// Initialize QR code functionality once the library is loaded
script.onload = () => {
    const modal = document.getElementById('wechat-qr-modal');
    const closeBtn = document.querySelector('.gh-qr-modal-close');
    const qrContainer = document.getElementById('wechat-qr-code');

    // Close modal when clicking the close button or outside the modal
    if (closeBtn && modal) {
        closeBtn.onclick = () => modal.style.display = 'none';
        window.onclick = (event) => {
            if (event.target === modal) {
                modal.style.display = 'none';
            }
        };
    }
};

// Function to show QR code modal
function showQRCode(url) {
    const modal = document.getElementById('wechat-qr-modal');
    const qrContainer = document.getElementById('wechat-qr-code');

    // Clear previous QR code
    qrContainer.innerHTML = '';

    // Generate new QR code
    QRCode.toCanvas(qrContainer, url, { width: 200 }, (error) => {
        if (error) console.error(error);
    });

    // Show modal
    modal.style.display = 'flex';
}